// MeetTheTeam.js
import React, { useState, useEffect } from "react";
import logoHead from "../images/Logo_head_white.png";
import TeamMemberCard from "../components/TeamMemberCard";
import LandonImage from "../images/Team/LandonAmaba.png"
import NitishImage from "../images/Team/NitishGoel.jpg"
import KeeratImage from "../images/Headshot_Keerat_edited.JPEG"
import KristenImage from "../images/Team/KristenKanavy.jpg"
import AdelaideImage from "../images/Team/AdelaideDuffy.jpg"


const colors = {
  mainBlue: "#061941",
  cafeNoir: "#583E23",
  carrieban: "#3C6E71",
  isabelline: "#F4F3EE",
  gold: "#F2AF29"
};

const teamMembers = [
  {
    id: 1,
    name: "Landon Amaba",
    role: "Founder & CEO",
    school: "University of Florida",
    major: "Electrical Engineering",
    image: LandonImage,
    website: "https://www.linkedin.com/in/landonamaba/"
  },
  {
    id: 2,
    name: "Keerat Kohli",
    role: "Chief Product Officer",
    school: "University of Florida",
    major: "Computer Science + Mathematics",
    image: KeeratImage,
    website: "https://www.linkedin.com/in/keerat-kohli/"
  },
  {
    id: 3,
    name: "Kristen Kanavy",
    role: "Marketing Director",
    school: "University of Florida",
    major: "Marketing",
    image: KristenImage,
    website: "https://www.linkedin.com/in/kristen-kanavy/"
  },
  {
    id: 4,
    name: "Adelaide Duffy",
    role: "Marketing Director",
    school: "University of Florida",
    major: "Business Administration",
    image: AdelaideImage,
    website: "https://www.linkedin.com/in/adelaide-duffy-6aa014283/"
  },


];

export default function MeetTheTeam() {
  const [visibleMembers, setVisibleMembers] = useState([]);

  useEffect(() => {
    // Stagger the fade-in animations
    teamMembers.forEach((_, index) => {
      setTimeout(() => {
        setVisibleMembers(prev => [...prev, index]);
      }, index * 300);
    });
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(120deg, ${colors.mainBlue} 70%, ${colors.gold} 92%, ${colors.gold} 100%)`,
        fontFamily: "Segoe UI, Arial, sans-serif",
        paddingBottom: "7rem"
      }}
    >
      <header
        style={{
          padding: "2.3rem 1rem 1.7rem 1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1.2rem"
        }}
      >
        <img
          src={logoHead}
          alt="NeuHawk logo"
          style={{ height: "64px", width: "64px" }}
        />
        <h1
          style={{
            fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
            fontSize: "2.4rem",
            fontWeight: 800,
            letterSpacing: "2px",
            color: colors.isabelline,
            margin: 0,
            lineHeight: 1.1
          }}
        >
          Meet the Team
        </h1>
      </header>

      <main
        style={{
          maxWidth: 1150,
          margin: "0 auto",
          padding: "0 1rem"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4rem",
            alignItems: "center"
          }}
        >
          {teamMembers.map((member, index) => (
            <TeamMemberCard
              key={member.id}
              member={member}
              isEven={index % 2 === 0}
              isVisible={visibleMembers.includes(index)}
            />
          ))}
        </div>
      </main>
    </div>
  );
}